import { RMAItem } from "./RMAItem";

export class RMA{
  public constructor() {
    this.Expanded = false;
    this.RMAVerificationPath = "";
    this.RMAItems = [];
  }

  public RMANumber: string;
  public ReceiptDate: Date;
  //public RMAStatus: string;
  public CustomerNumber: string;
  public DistributorName: string;
  public Price: number;
  //public OrderNumber: string;
  public PONumber: string; 
  //public Reason: string;
  //public EvalDate?: Date;
  //public EvalCode: string;
  //public Disp: string;
  //public ProbCode: string;
  //public Quantity: number;
  public ShipToName: string;
  //public ShipDate?: Date;
  //public EstShipDate?: Date;
  //public DispDate?: Date;
  //public DispDesc: string;  
  //public RepairOrder: string;
  public ToloContact: string;
  public TakenByName: string;
  public TakenByEmail: string;
  public RMARowPointer: string;
  //public RMAVerificationDate?: Date;
  public RMAVerificationPath: string;
  public RMAEvalPath: string;
  public RMAItems: RMAItem[];

  //public ShortReason: string;
  public ShortShipTo: string;
  public Following: boolean;
  public Expanded: boolean;
}

